<template>
    <div class="c-quantity-formats-box">
        <div class="c-quantity-text top">
            Nº de alvéolos por bandeja
            <img v-b-modal.modal-nalveolos src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
            <modal-block v-cloak title="Nº de alvéolos por bandeja" :href="route('help.details','dimensiones-alveolos')" desing="ecologico" refer="nalveolos">
                Cantidad de alvéolos por bandeja, el tamaño varía dependiendo del número alvéolos.
            </modal-block>
        </div>
        <b-form-checkbox v-model="showRecommended" class="c-quentity-format-recommend">
            El formato de bandeja que Babyplant me recomienda <img v-b-modal.modal-formatorec src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
            <modal-block v-cloak title="No toda semilla germina" desing="ecologico" refer="formatorec">
                Recuerda que no toda la semilla germina, te garantizamos como mínimo un 90% del número de plantas.
            </modal-block>
        </b-form-checkbox>
        <div class="c-inputs-box">
            <div v-for="trayFormatsGroup in trayFormatsDesign">
                <div v-for="trayFormat in trayFormatsGroup">
                    <div class="c-num-alveoli" :class="{'recommended': trayFormat.id === trayFormatRecommendedId && showRecommended}">
                        <div v-if="trayFormat.id === trayFormatRecommendedId && showRecommended" class="recommended-border"></div>
                        {{ trayFormat.unidades }}
                    </div>
                    <div>
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button @click="less(trayFormat)" class="c-btn-quantity-plus left">-</b-button>
                            </b-input-group-prepend>
                            <b-form-input :value="trayFormat.value" @input="input(trayFormat, $event)" class="c-quantity-input"></b-form-input>
                            <b-input-group-append>
                                <b-button @click="more(trayFormat)" class="c-btn-quantity-plus right">+</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-quantity-text bottom">
            Número de plantas: {{ numPlants }}
            <img v-b-modal.modal-nplantas src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
            <modal-block v-cloak title="Número de plantas" desing="ecologico" refer="nplantas">
                Número total de plantas que recibirás independientemente del formato de bandeja que escojas
            </modal-block>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlveolusQuantity",
        props: {
            trayFormats: {
                type: Array,
                default: []
            },
            trayFormatRecommendedId: {
                type: Number|String
            },
            injerto: {
                type: Boolean,
                default: false
            },
            seedLostPercent: {
                type: Number
            }
        },
        data() {
            return {
                loadingTrayFormats: false,
                showRecommended: false
            }
        },
        computed: {
            numPlants() {
                let numPlants = 0;
                this.trayFormats.forEach(tf => {
                    numPlants += parseInt(tf.unidades) * (parseInt(tf.value) || 0);
                });
                if (!this.injerto && numPlants > 0) {
                    numPlants -= Math.ceil(numPlants * this.seedLostPercent / 100);
                }
                return numPlants;
            },
            trayFormatsDesign() {
                let trayFormatsDesing = [];
                let auxAdd = [];
                let isPar = !(this.trayFormats.length % 2);
                this.trayFormats.forEach((tf, index) => {
                    auxAdd.push(tf);
                    if (!isPar || index % 2) {
                        trayFormatsDesing.push(auxAdd);
                        auxAdd = [];
                    }
                });
                return trayFormatsDesing;
            }
        },
        watch: {
            numPlants() {
                this.$emit('num-plants-changed', this.numPlants);
            }
        },
        methods: {
            input(trayFormat, value) {
                let newValue = parseInt(value);
                if (isNaN(newValue)) {
                    newValue = trayFormat.value;
                }
                trayFormat.value = newValue;
                this.$forceUpdate();
            },
            more(trayFormat) {
                let value = parseInt(trayFormat.value) || 0;
                value++;
                trayFormat.value = value;
            },
            less(trayFormat) {
                let value = parseInt(trayFormat.value) || 0;
                if (value > 0) {
                    value--;
                }
                trayFormat.value = value;
            }
        },
        created() {
            this.$emit('num-plants-changed', this.numPlants);
        }
    }
</script>

<style scoped>

    .c-quantity-input {
        min-width: 2.8em;
        width: 2.8em;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
        font-weight: bold;
    }

    .c-inputs-box {
        display: flex;
        margin: -0.5em;
        flex-wrap: wrap;
    }

    .c-inputs-box > * {
        flex: 1 1 auto;
        display: flex;
        flex-wrap: wrap;
    }

    .c-inputs-box > * > * {
        flex: 1 1 auto;
        margin: 0.5em;
    }

    .c-inputs-box .input-group-prepend, .input-group-append {
        flex: 1 1 0%;
    }

    .c-btn-quantity-plus {
        background-color: #fbc531;
        color: #5b5b5c;
        font-weight: bold;
        border-color: #cbc8c9;
        padding: 0.375rem 0.5rem;
        flex: 1 1 auto;
    }

    .c-btn-quantity-plus.left {
        border-right: 0;
    }

    .c-btn-quantity-plus.right {
        border-left: 0;
    }

    .c-num-alveoli {
        padding: 0.375rem 0.75rem;
        background-color: #fbc531;
        margin-bottom: 0.75rem;
        border-radius: 0.25rem;
        color: #0b72b8;
        font-size: 1.2em;
        font-weight: bold;
    }

    .c-num-alveoli.recommended {
        background-color: #048b84;
        color: #fff;
        position: relative;
    }

    .c-num-alveoli.recommended .recommended-border {
        width: calc(100% + 8px);
        height: calc(100% + 8px);
        position: absolute;
        left: -4px;
        top: -4px;
        border: solid 1px #048b84;
        border-radius: 0.25rem;
    }

    .c-quantity-formats-box .c-quantity-text {
        text-align: left;
        font-weight: bold;
        line-height: 1;
    }

    .c-quentity-format-recommend {
        text-align: left;
        font-weight: bold;
        margin-bottom: 0.75rem;
        color: #048b84;
    }

    .c-quantity-formats-box .c-quantity-text.top {
        margin-bottom: 0.75rem;
    }

    .c-quantity-formats-box .c-quantity-text.bottom {
        margin-top: 0.75rem;
    }

    @media (min-width: 992px) {
        .c-quantity-formats-box {
            padding: 0.75rem 1.75rem;
            border-radius: 0.25rem;
            border: 1px solid #cbc8c9;
        }

        .c-quantity-formats-box .c-quantity-text.top {
            margin-bottom: 0.75rem;
        }

        .c-quantity-formats-box .c-quantity-text.bottom {
            margin-top: 1rem;
        }
    }


</style>


<style>
    .c-quentity-format-recommend .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #048b84;
        background-color: #048b84;
    }
</style>
